import { Link } from "react-router-dom";
import { articles } from "../../../mocks/articles";

export default function Hero() {
  const lead = articles.find((a) => a.category === "cover")!;
  const rightTop = articles.find((a) => a.slug === "yanqu-rouyu-shou-jingzhen")!;
  const rightList = articles
    .filter((a) => a.category !== "cover" && a.slug !== "yanqu-rouyu-shou-jingzhen")
    .slice(0, 4);

  return (
    <section className="pt-32 md:pt-40 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* 顶部导语横幅 */}
        <div className="flex flex-col items-start justify-between gap-3 border-b border-background-200 pb-5 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.25em] text-accent-700">
              <i className="ri-calendar-event-line text-sm" aria-hidden="true"></i>
              2026 · 深度吃瓜周报
            </p>
            <h1 className="mt-2 font-serif text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
              不止吃瓜，更看懂门道
            </h1>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
              今日瓜报 · 头条解读 · 重点瓜分析 · 深度报道 · 封面故事，讲透娱乐热点的来龙去脉。
            </p>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-600 md:text-sm">
            {["编辑甄选", "信源求证", "观点独立"].map((t) => (
              <span key={t} className="flex items-center gap-1.5 whitespace-nowrap text-secondary-700">
                <i className="ri-check-double-line text-accent-600" aria-hidden="true"></i>
                {t}
              </span>
            ))}
          </div>
        </div>

        {/* 头条主编内容区：不对称双栏 */}
        <div className="mt-8 grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* 封面主稿 */}
          <div className="lg:col-span-7">
            <Link to={`/article/${lead.slug}`} className="group block">
              <div className="relative overflow-hidden rounded-xl bg-background-100">
                <img
                  src={lead.image}
                  alt={lead.imageAlt}
                  title={`${lead.title} - 今日瓜报封面故事`}
                  className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                    <i className="ri-book-open-line" aria-hidden="true"></i>
                    本期封面故事
                  </span>
                  <h2 className="mt-3 font-serif text-xl font-black leading-snug text-background-50 md:text-3xl">
                    {lead.title}
                  </h2>
                  <p className="mt-2 line-clamp-2 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
                    {lead.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* 右侧头条解读 + 列表 */}
          <div className="lg:col-span-5">
            <div className="rounded-xl bg-background-100 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h2 className="flex items-center gap-2 font-serif text-lg font-bold text-foreground-950">
                  <i className="ri-flashlight-fill text-primary-600" aria-hidden="true"></i>
                  今日头条解读
                </h2>
                <Link to="/#feed" className="text-xs text-primary-700 hover:underline">
                  全部 →
                </Link>
              </div>
              <Link to={`/article/${rightTop.slug}`} className="group mt-4 block">
                <div className="relative overflow-hidden rounded-lg">
                  <img
                    src={rightTop.image}
                    alt={rightTop.imageAlt}
                    title={`${rightTop.title} - 今日瓜报`}
                    className="aspect-[16/9] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h3 className="mt-3 font-serif text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors md:text-lg">
                  {rightTop.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{rightTop.excerpt}</p>
              </Link>
              <div className="mt-5 space-y-4 border-t border-background-200 pt-5">
                {rightList.slice(0, 3).map((a) => (
                  <Link to={`/article/${a.slug}`} key={a.slug} className="group flex gap-3">
                    <span className="mt-0.5 font-serif text-sm font-bold text-secondary-400">0{rightList.indexOf(a) + 1}</span>
                    <span className="flex-1 font-serif text-sm font-semibold leading-snug text-foreground-800 group-hover:text-primary-700 transition-colors">
                      {a.title}
                    </span>
                    <i className="ri-arrow-right-line self-center text-secondary-400 opacity-0 transition-opacity group-hover:opacity-100" aria-hidden="true"></i>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}